import React from "react";
import cn from "classnames";
import styles from "./ExplanationPanel.module.css";

import ExplanationWrongImage from "../../images/explanation-wrong.png";

export function ExplanationPanel({ children, image, isShown }) {
  const panelImage = image ? image : ExplanationWrongImage;

  return (
    <div className={cn(styles.textPanel, isShown ? styles.showTextPanel : "")}>
      <div className="container">
        <img src={panelImage} alt="Text panel" />
        <div className={styles.textPanelContent}>{children}</div>
      </div>
    </div>
  );
}

export default ExplanationPanel;
